import { render } from "./PdpContainer.vue?vue&type=template&id=5559abe2"
import script from "./PdpContainer.vue?vue&type=script&lang=js"
export * from "./PdpContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__